import { $, $$ } from 'dlr-utils/helpers';

/**
 * IMPORTANT: THIS WILL ALWAYS BE AN ARRAY
 * Always make it possible for multiple instances
 * of your module to work on the pages.
 */
const SELECTOR = '.dlr-impact-hero';
const INSTANCES = $$(SELECTOR);

/* If you want to target just one, just uncomment the line below */
const ELEMENT = INSTANCES[0];

/**
 * 1. Mounting
 *
 * Put module-specific variables and functions here.
 * Actions in this scope will fire as soon as the module
 * is mounted (not yet attached to the page)
 *  e.g. setting of initial states (see below), data fetching, etc
 *
 * The default export functions are the only
 * ones used by the dynamic module importer (main.js).
 * upon page load. main.js will only fire these if
 * at least one element with the class ".dlr-spotlight" exists
 */
const state = {};
const hero = ELEMENT;
const sticky = $(`${SELECTOR}__sticky`, hero);
let scrollY = 0
let opacity = 0;

export default {
  /**
   * 2. REGISTRATION
   *
   * Use `init` for actions that should fire as soon as
   * the module file has been made available to the page
   *  - e.g. data transformations, MessageBus Subscriptions
   */
  init(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;

    MessageBus.subscribe('SCROLL_HANDLER', event => {
      scrollY = event.scrollY || window.scrollY;
      opacity = scrollY / (hero.offsetHeight - sticky.offsetHeight);
      opacity = opacity >= 1 ? 1 : opacity;

      sticky.style.setProperty('--opacity', opacity);
    });
  },

  /**
   * 3. RENDERING
   *
   * Use `finalize` for actions that should run
   * as soon as the module is rendered to the page
   * - e.g. Event Listeners, DOM Manipulations,
   *        MessageBus Publishers, etc
   */
  finalize(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;

    MessageBus.publish('SCROLL_HANDLER');
    onScroll(scrollEvent => MessageBus.publish('SCROLL_HANDLER', scrollEvent));
  },
};



// WEBPACK FOOTER //
// ../views/modules/impact-hero/impact-hero.js